import { Injectable } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, of, forkJoin } from 'rxjs';
import { OrderService, LLFormService, SettingsService } from '../../shared/services/index';

@Injectable()
export class OrderResolverService implements Resolve<any> {

    constructor(
        private orderService: OrderService,
        private llService: LLFormService,
        private settingsService: SettingsService
    ) {
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
        const orderRevisionId = route.params.orderRevisionId;
        const customerGuid = this.settingsService.getCustomerGuid();
        const retVal = forkJoin([
            // 0: List of employees in current customer
            customerGuid ? this.orderService.getEmployees(customerGuid) : of(null),
            // 1: reference data - service types by service category
            this.orderService.getServiceCategoryToServiceTypeAssoc(),
            // 2: reference data - delivery priorities by service type list
            this.orderService.getServiceTypeToDevlieryPriorityAssoc(),
            // 3: Order (as IApiTypedResult<Order>)
            orderRevisionId ? this.orderService.getOrderByOrderRevisionId(orderRevisionId)
                .pipe(catchError(this.orderService.handleOrderObjectError)
                ) : of(null),
            // 4: LL forms
            this.llService.getLLForms(),
            // 5: order statuses
            this.orderService.getOrderStatuses(),
            // 6: service categories
            this.orderService.getServiceCategories(),
            // 7: country ServiceGroup
            this.orderService.getCountryServiceGroups(),
            // 8: country ServiceType
            this.orderService.getCountryServiceTypes(),
        ])
        .pipe(catchError(err => of({ error: err })));

        return retVal;
    }
}
